import triggerWindowResize from '../../../utility/triggerWindowResize';
import GlideSlider from '../base';

const glideOptions = {
  type: 'slider',
  startAt: 0,
  perView: 1,
  bound: true,
  gap: 16,
};

export default class testimonialsSlider {
  constructor(el) {
    this.el = el;
    this.initSlider();
    triggerWindowResize();
  }

  initSlider() {
    this.testimonialsSlider = new GlideSlider(
      this.el,
      glideOptions,
    );

    this.testimonialsSliderGlideInstance = this.testimonialsSlider.getGlideSlider();
    this.testimonialsSliderGlideInstance.mount();
  }
}
